import React from 'react';

const JobConfigList = {
  settings: {
    layout: {
      config: {}
    }
  },
  auth: ['ROLE_JOB', 'ROLE_JOB_LIST', 'ROLE_SUPER_ADMIN'],
  routes: [
    {
      path: '/jobs',
      component: React.lazy(() => import('./jobs_list'))
    }
  ]
};

const JobAddConfig = {
  settings: {
    layout: {
      config: {}
    }
  },
  auth: ['ROLE_JOB', 'ROLE_JOB_ADD', 'ROLE_SUPER_ADMIN'],
  routes: [
    {
      path: '/job/add',
      component: React.lazy(() => import('./job_add'))
    }
  ]
};

const JobEditConfig = {
  settings: {
    layout: {
      config: {}
    }
  },
  auth: ['ROLE_JOB', 'ROLE_JOB_EDIT', 'ROLE_SUPER_ADMIN'],
  routes: [
    {
      path: '/job/:id',
      component: React.lazy(() => import('./job_add'))
    }
  ]
};

export { JobEditConfig, JobAddConfig, JobConfigList };
